module.exports = __webpack_public_path__ + "img/product-include.6a70b4e3.png";